import React from 'react';
import '../css/TextFile.css';

function Experience(){
    
    return (
        <div className="textfile-container">
            <h4>Software Engineer</h4>
            <p>JPMorgan Chase &amp; Co.</p>
            <p>June 2020 - present</p>
            <br/>

            <h4>Frontend Engineer Intern</h4>
            <p>Sumo Logic Inc.</p>
            <p>June 2019 - August 2019</p>
            <br/>

            <h4>Software Engineer Intern</h4>
            <p>SAP</p>
            <p>June 2018 - August 2018</p>
        </div>
    )

}

export default Experience;